<script>
    import {afterUpdate} from 'svelte'
    import inputmask from 'inputmask'
    import {_hasOwnProperty} from '../js/utils.js'

    let workTimeMode = 1
    export let workTime = []
    export let days = []
    export let formName

    let startTime = ''
    let endTime = ''
    afterUpdate(() => {
        const workTimeInput = document.querySelectorAll('.js-timepicker')
        inputmask('99:99').mask(workTimeInput)
    })

    if (workTime) {
        for (const d of days) {
            if (_hasOwnProperty(workTime, d.id)) {
                const w = workTime[d.id]
                if (!startTime && !endTime) {
                    startTime = w.start
                    endTime = w.end
                    workTimeMode = 1
                } else if (startTime !== w.start || endTime !== w.end) {
                    workTimeMode = 2
                    break
                }
            }
        }
    }

    function startWorkTime(day) {
        if (_hasOwnProperty(workTime, day)) {
            const i = workTime[day]
            if (_hasOwnProperty(i, 'start')) {
                return i.start
            }
        }
        return ''
    }

    function endWorkTime(day) {
        if (_hasOwnProperty(workTime, day)) {
            const i = workTime[day]
            if (_hasOwnProperty(i, 'end')) {
                return i.end
            }
        }
        return ''
    }
</script>
<div class="clearfix mb-3">
    <h4 class="float-start me-3">Время работы</h4>
    <div aria-label="Work time mode" class="btn-group" role="group">
        <input autocomplete="off" bind:group={workTimeMode} class="btn-check" id="btnradio1" name="workTimeMode"
               type="radio" value={1}>
        <label class="btn btn-outline-primary" for="btnradio1">Кратко</label>

        <input autocomplete="off" bind:group={workTimeMode} class="btn-check" id="btnradio2" name="workTimeMode"
               type="radio" value={2}>
        <label class="btn btn-outline-primary" for="btnradio2">Детально</label>
    </div>
</div>
{#if workTimeMode === 2}
    {#each days as day}
        <div class="row mb-3">
            <div class="col">{day.name}</div>
            <div class="col">
                <input type="text"
                       name="{formName}[work_time][{day.id}][start]"
                       class="form-control js-timepicker"
                       value="{startWorkTime(day.id)}"
                >
            </div>
            <div class="col">
                <input type="text"
                       name="{formName}[work_time][{day.id}][end]"
                       class="form-control js-timepicker"
                       value="{endWorkTime(day.id)}"
                >
            </div>
        </div>
    {/each}
{:else}
    <div class="row mb-3">
        <div class="col">Ежедневно</div>
        <div class="col">
            <input type="text" bind:value={startTime} class="form-control js-timepicker">
        </div>
        <div class="col">
            <input type="text" bind:value={endTime} class="form-control js-timepicker">
        </div>
        {#each days as day}
            <input type="hidden" name="{formName}[work_time][{day.id}][start]" value="{startTime}">
            <input type="hidden" name="{formName}[work_time][{day.id}][end]" value="{endTime}">
        {/each}
    </div>
{/if}
